import * as React from 'react';
import './index.css';
import { DynamicTagGroup } from '@/components/DynamicTag';

interface IState {}

interface Props {
  model: any;
}

export default class DynamicTagGroupItemView extends React.Component<Props, IState> {
  render() {
    const { model } = this.props;
    const data = model.originalData;
    if (!data?.promotionTags) {
      return null;
    }
    return (
      <view className="dynamic-tag-view" style={{ flexShrink: 1 }} key={`${data?.name}`}>
        <DynamicTagGroup {...data?.promotionTags?.discountTag} maxLines={this.props.model.shouldDynamicTagsTwoLines ? 2 : 1} />
      </view>
    );
  }
}
